export default "__VITE_ASSET__Dlnm9x1j__"